import React from 'react';
import { Box, Text } from '@chakra-ui/react';

interface CompletionScreenProps {
  title?: string;
  subtitle?: string;
}

const CompletionScreen: React.FC<CompletionScreenProps> = ({
  title = "Our team is reviewing your profile",
  subtitle = "You will receive an email from us within the next 24 hours",
}) => {
  return (
    <>
      {/* Success Icon */}
      <Box
        position="absolute"
        top="10px"
        left="50%"
        transform="translateX(-50%)"
        width="120px"
        height="120px"
        backgroundColor="#C6D959"
        borderRadius="50%"
        display="flex"
        alignItems="center"
        justifyContent="center"
        marginBottom="32px"
      >
        <svg width="60" height="60" viewBox="0 0 60 60" fill="none">
          <path d="M20 30L27 37L40 24" stroke="#0C1301" strokeWidth="3" strokeLinecap="round" strokeLinejoin="round"/>
        </svg>
      </Box>

      {/* Success Message */}
      <Box
        position="absolute"
        top="200px"
        left="22px"
        width="332px"
        textAlign="center"
      >
        <Text
          className="title-text-center"
          marginBottom="16px"
        >
          {title}
        </Text>
        <Text
          className="static-text"
          marginBottom="32px"
        >
          {subtitle}
        </Text>
      </Box>
    </>
  );
};

export default CompletionScreen;
